import { Injectable } from '@angular/core';
import {BehaviorSubject, of} from 'rxjs';
import { Email } from '../model/Email';
import { SdApiService } from './base/sd-api.service';
import { LoadingStateService } from './base/loading-state.service';
import { FeedService } from './feed.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MailCategory} from '../model/MailCategory';
import {MailAction} from '../model/MailAction';
import { Notification } from '../model/Notification';
import { NotificationsService } from 'src/app/services/notifications.service';
import { NotificationType } from '../model/NotificationType';
import { NotificationCategory } from '../model/NotificationCategory';
import { NotificationDismissType } from '../model/NotificationDismissType';
import { UIGuid } from '../helpers/ui-guid';
import { ActionService } from './action.service';
import { delay } from 'rxjs/operators';
import { LogService } from './log.service';
import { IDiscrepancy } from '../model/Discrepancy';

const MODAL_DURATION = 5000;
const UNDO_STANDBY_TIME = 10 * 1000;
const CLASSIFY_MILLISECONDS_COOLDOWN = 500;

@Injectable({
  providedIn: 'root'
})
export class SelectedDiscrepancyService {
  private selectedEmailFeed = new BehaviorSubject<Email>(null);
  private selectedDiscrepancy = new BehaviorSubject<IDiscrepancy>(null);
  private bulkSelectionFeed = new BehaviorSubject<Email[]>([]);
  private clickedEmail = new BehaviorSubject<string>('');
  private activeActions = new Map<string, MailAction>();
  private currentMail: Email;
  public bulkMailSelection: Email[] = [];
  private lastClassificationTime = 0;
  private lastClassificationDate;
  selectedFolder = '';


  constructor(
    private sdApiService: SdApiService,
    private loadingStateService: LoadingStateService,
    private feedService: FeedService,
    private snackBar: MatSnackBar,
    private notificationsService: NotificationsService,
    private actionsService: ActionService,
    private logService: LogService
  ) {
    this.feedService.selectedFolder.subscribe(folderValue => {
      this.selectedFolder = folderValue;
    });
  }

  get selectedEmail() {
    return this.selectedEmailFeed.asObservable();
  }

  get selectedLog() {
    return this.selectedDiscrepancy.asObservable();
  }

  selectMail(email: Email) {
    this.currentMail = email;
    this.selectedEmailFeed.next(email);
  }

  selectDiscrepancy(discrepancy: IDiscrepancy) {
    this.selectedDiscrepancy.next(discrepancy);
  }

  setClickedEmail(email: string) {
    this.clickedEmail.next(email);
  }

  get clickedEmailToSearch() {
    return this.clickedEmail.asObservable();
  }

  setLoadingAndRemoveFromFeed(email: Email) {
    this.loadingStateService.setLoadingState(true);
    // this.movingMail = true;
    this.feedService.removeMailFromFeed(email);
    this.selectMail(this.feedService.getFirstMail());
  }

  

  

  

  formatAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  saveAction(action: MailAction) {
    if (!this.activeActions.get(action.actionId)) {
      this.activeActions.set(action.actionId, action);
    } else
      console.log("ERROR: Duplicated action ID!");
  }

  get isSafeToUpdate() {
    return true; // !this.movingMail && !this.undoingAction;
  }

  clearAction(action: MailAction) {
    if (this.activeActions.has(action.actionId))
      this.activeActions.delete(action.actionId);
  }

  selectAll(mails: Email[]) {
    this.bulkMailSelection = [];
    this.bulkMailSelection.push(...mails);
    this.bulkSelectionFeed.next(this.bulkMailSelection);
  }

  clearAll() {
    this.bulkMailSelection = [];
    this.bulkSelectionFeed.next(this.bulkMailSelection);
  }

  toggleMailInBulkSelection(mail: Email, forceAdd?: boolean) {
    const index = this.bulkMailSelection.indexOf(mail);
    // console.log(index);
    if (index > -1) {
      if (!forceAdd)
        this.bulkMailSelection.splice(index, 1);
    } else {
      this.bulkMailSelection.push(mail);
    }
    this.bulkSelectionFeed.next(this.bulkMailSelection);
  }

  isMailInBulkSelection(email: Email) {
    return this.bulkMailSelection.indexOf(email) > -1;
  }

  get emailBulkSelection() {
    return this.bulkSelectionFeed.asObservable();
  }

  refresh() {
    this.selectMail(null);
    this.feedService.refresh();
  }

  classificationColor(classification: string) {
    let color = "black";
    switch (classification.toLowerCase()) {
      case "21 - unsubscribe company":
        color = "#9E2C21";
        break;
      case "20 - bad fit company":
        color = "#9E2C21";
        break;
      case "25 - competitor":
        color = "#9E2C21";
        break;
      case "10 - client":
        color = "#9E2C21";
        break;
      case "converted":
        color = "#19709E";
        break;
      case "review":
        color = "#729E2F";
        break;
    }
    return color;
  }

}
